// eslint-disable-next-line no-template-curly-in-string
export const FEATURED_HERE_TEST_ID = 'news-featured-here';
export const MIN_CARDS_TO_SHOWED = 1;
